export default __webpack_public_path__ + "static/moroccan_gold-d01057a74f5492d3dfc57d254328e9ee.png";